import Dialog from './Dialog';
import useDialog from './use-dialog';
import LockBodyScroll from './LockBodyScroll';

export default Dialog;
export { useDialog, LockBodyScroll };
